export default {
	api: {
		endpoint: 'https://admin.eeuwigetuinen.nl/api'
	}
};